module.exports = {
  name: 'Longhorn UI',
  prefix: 'antdAdmin',
  logoSrc: 'favicon.ico',
  version: '0f560ca', // eslint-disable-line no-template-curly-in-string
}
